<template>
	<div class="">
				<div class="row">
			<div class="col-md-9">
				<div class="card">
					<div class="card-header with-border">Схема зала
						<div class="card-header-actions">
								<button type="button" class="card-header-action" @click="updateData()"><i class="fa fa-refresh"></i></button>
						</div>
					</div>
					<div class="card-body">
						<div class="seats-reserver-map">
							<div v-for="(subitems, key) in items" v-bind:key="key" v-bind:class="'fill-' + subitems.meta.level" class="seats-row">
								<div class="seats-row__label first">{{ key }}</div>
								<div class="seats-row__seats">
									<div v-for="(item, key2) in subitems.items" v-bind:key="key2" v-bind:class="[item == '' ? 'empty' : '']" class="seats-cell">
										<div v-if="popover === key + item" class="popover bottom">
											<div class="arrow"></div>
											<h3 class="popover-title">Информация о брони</h3>
											<div class="popover-content">
												<dl>
													<dt>Менеджер:</dt>
													<dd>{{ popoverContent.manager }}</dd>
													<dt>ID сделки:</dt>
													<dd>{{ popoverContent.dealId }}</dd>
													<dt>E-mail адреса для отправки билетов:</dt>
													<dd>{{ popoverContent.email }}</dd>
													<dt>Дата резервирования:</dt>
													<dd>{{ popoverContent.reservedAt }}</dd>
													<dt>Статус:</dt>
													<dd>{{ popoverContent.status }}</dd>
												</dl>
											</div>
										</div>
										<input
											type="checkbox"
											:id="key + item"
											:value="key + item"
											:data-level="subitems.meta.level"
											:data-name="subitems.meta.name"
											:data-color="subitems.meta.color"
											:disabled="isDisabled(subitems, item, key)"
											v-model="checkbox"
											:true-value="true"
											:false-value="false"
										>
										<label
											class="label"
											:class="isReserved(key, item) === true ? 'label-info' : 'label-default'"
											v-bind:for="key + item"
											@mouseover="mouseover(key, item)"
											@mouseleave="mouseleave"
											><span>{{ item }}</span>
										</label>
									</div>
								</div>
								<div class="seats-row__label second">{{ key }}</div>
							</div>
						</div>
					</div>
					<div class="card-footer">
						<b-button class="pull-left" variant="primary" @click="$router.push('/live')">Режим мероприятия</b-button>
						<b-button class="pull-right" variant="primary" @click="$router.push({path: '/events/reservation/' + eventId})">Мои бронирования</b-button>
					</div>
				</div>
			</div>
			<div class="col-md-3">
				<div class="seats-reserver-info">
					<div class="card">
						<div class="card-header">Выбранные места
							<div class="card-header-actions">
								<b-badge variant="success" data-original-title="Количество выбранных мест">{{ checkbox.length }}</b-badge>
								<b-button size="sm" @click="reset()"><i class="fa fa-refresh"></i></b-button>
							</div>
						</div>
						<div class="card-body">
							<div v-if="checkbox.length > 0" class="table-responsive">
								<table class="table no-margin reservation">
									<thead>
									<tr>
										<th>Ряд:</th>
										<th>Место:</th>
										<th>Категоря:</th>
									</tr>
									</thead>
									<tbody>
									<tr v-for="(item, key) in checkbox" :key="key" class="reservation__row">
										<td class="reservation__cell">{{ getOnlyLetter(item) }}</td>
										<td class="reservation__place">{{ getOnlyNumber(item) }}</td>
										<td class="reservation__level"><span :class="'badge badge-' + getSeatAttributes(item).color">{{ getSeatAttributes(item).name }}</span></td>
									</tr>
									</tbody>
								</table>
							</div>
						</div>
						<div v-if="checkbox.length > 0" class="card-footer">
							<b-button class="pull-left" variant="primary" @click="open=true">Забронировать места</b-button>
						</div>
					</div>
				</div>
			</div>
		</div>

		<b-modal id="modallg" v-model="open" cancel-title="Отмена" size="lg" @cancel="resetModal" @ok="reserve" title="Заполнение данных для подтверждение брони" class="modal-seat-manage">
			<h4>Пожалуйста, заполните следующие поля:</h4>
			<form>
				<alert type="danger" v-if="alert" dismissible @dismissed="alert = false">{{ alertText }}</alert>
				<div class="form-group" :class="errors.bitrix24 === true ? 'has-error' : ''">
					<label for="bitrixId" class="col-form-label">ID сделки в Bitrix24</label>
					<input type="text" class="form-control" id="bitrixId" v-model="form.bitrixId" required>
					<small class="form-text text-muted">Должно быть целым числом.</small>
				</div>
				<div class="form-group" :class="errors.email === true ? 'has-error' : ''">
					<label for="email" class="col-form-label">E-mail</label>
					<textarea class="form-control" id="email" v-model="form.email" required></textarea>
					<small class="form-text text-muted">Необходимо ввести хотя бы один адрес электронной почты. Если их несколько, укажите их через запятую.</small>
				</div>
			</form>
		</b-modal>
	</div>
</template>
<script>
import items from '@/data'
export default {
	name: 'Index',
	data: function () {
		return {
			eventId: null,
			checkbox: [],
			reserved: [],
			items: items,
			form: {
				bitrixId: '',
				email: ''
			},
			errors: {
				bitrix24: false,
				email: false
			},
			open: false,
			alert: false,
			alertText: '',
			timeout: null,
			popover: '',
			popoverContent: {
				manager: '',
				dealId: null,
				email: '',
				reservedAt: '',
				status: ''
			}
		}
	},
	mounted: function () {
		this.eventId = this.$route.params.id
		this.checkReserved()
	},
	methods: {
		isDisabled: function (row, cell, key) {
			if (cell === '') {
				return 'disabled'
			}
			if (row.disabled === 'all') {
				return 'disabled'
			}
			for (let i = 0; i < this.reserved.length; i++) {
				if (this.reserved[i] === key + cell) {
					return 'disabled'
				}
			}
		},
		isReserved: function (row, cell) {
			for (let i = 0; i < this.reserved.length; i++) {
				if (this.reserved[i] === row + cell) {
					return true
				}
			}
		},
		getOnlyLetter: function (el) {
			return el.replace(/[^a-z]/gim, '')
		},
		getOnlyNumber: function (el) {
			return el.replace(/[^0-9]/gim, '')
		},
		getSeatAttributes: function (item) {
			let inputs = document.getElementsByTagName('input')
			for (let i = 0; i < inputs.length; i++) {
				if (inputs[i].value === item) {
					let result = {
						level: inputs[i].getAttribute('data-level'),
						name: inputs[i].getAttribute('data-name'),
						color: inputs[i].getAttribute('data-color')
					}
					return result
				}
			}
		},
		reserve: function (e) {
			e.preventDefault()
			this.form.bitrixId !== '' && this.form.bitrixId > 0 ? this.errors.bitrix24 = false : this.errors.bitrix24 = true
			this.form.email === '' ? this.errors.email = true : this.errors.email = false

			if (this.errors.bitrix24 === true || this.errors.email === true) {
				return false
			}

			let seat = []
			for (let i = 0; i < this.checkbox.length; i++) {
				seat.push({seat: this.checkbox[i], level: this.getSeatAttributes(this.checkbox[i]).level})
			}
			this.$http.post(this.$store.state.apiURL + '/v1/event/seats', {
				b24_deal_id: this.form.bitrixId,
				client_email: this.form.email,
				event_id: this.eventId,
				seat: seat
			}, {
			}).then(function (response) {
				this.open = false
				this.reset()
				this.resetModal()
				this.updateData()
				this.$notify({
					placement: 'bottom-right',
					title: 'Поздравляем!',
					content: 'Места успешно забронированны! Не забудье Игорямбе KitKat :).'
				})
			}, function (response) {
				this.alert = true
				this.alertText = response.body.errors.item[0]
			})
		},
		checkReserved: function () {
			let store = this.$store
			this.$store.commit('CALL_API_ON')
			this.$http.get(store.state.apiURL + '/v1/event/map/' + this.eventId, {}, {
			}).then(function (response) {
				let data = response.data
				this.reserved = data.data.items
				this.$store.commit('CALL_API_OFF')
			}, function (response) {
				this.$store.commit('CALL_API_OFF')
			})
		},
		updateData: function () {
			this.checkReserved()
			this.$notify({
				placement: 'bottom-right',
				title: 'Данные обнавлены!',
				content: ''
			})
		},
		modal: function (e) {
			console.log(e)
			if (e === 'cancel' || e === 'dismiss') {
				this.resetModal()
			}
			if (e === 'ok') {
				this.open = true
			}
		},
		reset: function () {
			this.checkbox = []
		},
		resetModal: function () {
			this.form.bitrixId = ''
			this.form.email = ''
			this.errors.bitrix24 = false
			this.errors.email = false
			this.alert = false
			this.alertText = ''
		},
		mouseover: function (row, cell) {
			clearTimeout(this.timeout)
			this.timeout = setTimeout(() => {
				clearTimeout(this.timeout)
				this.$http.get(this.$store.state.apiURL + '/v1/event/seats', {
					params: {
						event_id: this.eventId,
						seat: row + cell
					}
				}, {
				}).then(function (response) {
					if (response.data.length < 1) return false
					let data = response.data
					this.popoverContent.manager = data.manager
					this.popoverContent.dealId = 100 // data.reservation.b24_deal_id
					this.popoverContent.email = 'asdasd'// data.reservation.email
					this.popoverContent.reservedAt = 123 // data.reservation.reserved_at
					this.popoverContent.status = 'sdfdsf' // data.reservation.is_confirmed === 0 ? 'Не подтверждено' : 'Подтверждено'
					this.popover = row + cell
					// this.reserved = data.data.items
				}, function (response) {
				})
			}, 1000)
		},
		mouseleave: function () {
			clearTimeout(this.timeout)
			this.popover = ''
		}
	},
	computed: {
		cellClass: function (item) {
			return {
				active: this.isActive && !this.error,
				'text-danger': this.error && this.error.type === 'fatal'
			}
		}
	}
}
</script>

<style>
.app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.seats-row {
		-ms-flex-align: stretch;
    align-items: stretch;
    display: -ms-flexbox;
    display: flex;
		padding: 1px 10px;
}

.seats-row:first-child { padding-top: 10px; }
.seats-row:last-child { padding-bottom: 10px; }

.seats-row:hover {
	background: #f1f1f1;
}

.seats-row__seats {
	width: 100%;
  display: flex;
  justify-content: center;
	-ms-flex-align: stretch;
  align-items: stretch;
  display: -ms-flexbox;
  display: flex;
}

.seats-row__label {
	font-weight: bold;
	text-transform: uppercase;
}

.seats-row__label.second {
		-ms-flex-pack: end;
    justify-content: flex-end;
    margin-left: auto;
}

.seats-cell {
	position: relative;
	width: 22px;
	height: 22px;
	padding: 0;
	margin: 1px 2px;
	font-size: 12px;
	cursor: pointer;
}

.seats-cell label {
		-ms-flex-align: center;
	align-items: center;
	display: -ms-flexbox;
	display: flex;
	width: 100%;
	height: 100%;
	padding: 0;
	margin: 0;
	font-size: 12px;
	cursor: pointer;
}

.seats-cell label:hover {
	box-shadow: 0 0 0 0.2rem rgba(0,123,255,.5);
}

.seats-cell input {
	display: none;
}

.seats-cell input[type=checkbox]:disabled + label {
	cursor: default;
}

.seats-cell input[type=checkbox]:disabled + label.label-primary, .seats-cell input[type=checkbox]:disabled + label.label-info {
	cursor: default;
	opacity: 1;
}

.seats-cell input[type=checkbox]:disabled + label:hover {
	box-shadow: none;
}

.seats-cell input[type=checkbox]:checked + label {
	background: #333;
	-webkit-animation-name: rubberBand;
	animation-name: rubberBand;
	animation-duration: 300ms;
	animation-fill-mode: both;
}

.seats-cell span {
	width: 100%;
	text-align: center;
	font-weight: bold;
}

.seats-cell.empty {
	opacity: 0.1;
}

.seats-cell.reserved {
	background-color: #333;
}

.reservation__cell {
	text-transform: uppercase;
}

.reservation__place {

}

.reservation__level {
	font-weight: bold;
}

@-webkit-keyframes rubberBand {
  0% {
    -webkit-transform: scale3d(1, 1, 1);
            transform: scale3d(1, 1, 1);
  }

  30% {
    -webkit-transform: scale3d(1.25, 0.75, 1);
            transform: scale3d(1.25, 0.75, 1);
  }

  40% {
    -webkit-transform: scale3d(0.75, 1.25, 1);
            transform: scale3d(0.75, 1.25, 1);
  }

  50% {
    -webkit-transform: scale3d(1.15, 0.85, 1);
            transform: scale3d(1.15, 0.85, 1);
  }

  65% {
    -webkit-transform: scale3d(.95, 1.05, 1);
            transform: scale3d(.95, 1.05, 1);
  }

  75% {
    -webkit-transform: scale3d(1.05, .95, 1);
            transform: scale3d(1.05, .95, 1);
  }

  100% {
    -webkit-transform: scale3d(1, 1, 1);
            transform: scale3d(1, 1, 1);
  }
}

@keyframes rubberBand {
  0% {
    -webkit-transform: scale3d(1, 1, 1);
            transform: scale3d(1, 1, 1);
  }

  30% {
    -webkit-transform: scale3d(1.25, 0.75, 1);
            transform: scale3d(1.25, 0.75, 1);
  }

  40% {
    -webkit-transform: scale3d(0.75, 1.25, 1);
            transform: scale3d(0.75, 1.25, 1);
  }

  50% {
    -webkit-transform: scale3d(1.15, 0.85, 1);
            transform: scale3d(1.15, 0.85, 1);
  }

  65% {
    -webkit-transform: scale3d(.95, 1.05, 1);
            transform: scale3d(.95, 1.05, 1);
  }

  75% {
    -webkit-transform: scale3d(1.05, .95, 1);
            transform: scale3d(1.05, .95, 1);
  }

  100% {
    -webkit-transform: scale3d(1, 1, 1);
            transform: scale3d(1, 1, 1);
  }
}

.rubberBand {
  -webkit-animation-name: rubberBand;
          animation-name: rubberBand;
}

.fill-vip {
	background-color: rgba(221,75,57,0.3);
}

.fill-business {
	background-color: rgba(243,156,18,.3);
}

.label-default {
	background-color: #777;
	color: #fff;
}

.popover {
	display: block !important;
}
.popover.bottom {
	width: 400px !important;
	max-width: none !important;
	margin-top: 28px !important;
	margin-left: -190px !important;
}

</style>



// WEBPACK FOOTER //
// src/pages/event/map.vue